import { render, staticRenderFns } from "./editDaHuo.vue?vue&type=template&id=6842c83e&scoped=true&"
import script from "./editDaHuo.vue?vue&type=script&lang=js&"
export * from "./editDaHuo.vue?vue&type=script&lang=js&"
import style0 from "./editDaHuo.vue?vue&type=style&index=0&id=6842c83e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6842c83e",
  null
  
)

export default component.exports